package com.rajen.angrejidictionary.domain.model

/**
 * Thrown when a specific word lookup returns no match — as opposed to a
 * network failure, server error, or timeout. Kept distinct from a plain
 * Exception so the UI layer can show a friendly "not listed yet" state
 * instead of a generic error screen.
 */
class WordNotFoundException(message: String) : Exception(message)